{
  "wallboard": {
    "instances_count": "{count} Instanz | {count} Instanzen",
    "label": "Wallboard"
  }
}
